export enum CampaignTypes {
  Acquisition = 'acquisition',
  AcquisitionBasic = 'acquisition_basic',
  AcquisitionMessageRequest = 'acquisition_message_request',
  AcquisitionInmail = 'acquisition_inmail',
  AcquisitionViaImport = 'acquisition_via_import',
  AcquisitionCsv = 'acquisition_csv',
  AcquisitionCsvRb2b = 'acquisition_csv_rb2b',
  AcquisitionCsvInstantly = 'acquisition_csv_instantly',
  AcquisitionCsvSquid = 'acquisition_csv_asksquid',
  AcquisitionCsvApi = 'acquisition_csv_api',
  AcquisitionCsvZapier = 'acquisition_csv_zapier',
  AcquisitionCsvLikedPost = 'acquisition_csv_liked_post',
  AcquisitionCsvWebhook = 'acquisition_csv_webhook',
  AcquisitionCsvVector = 'acquisition_csv_vector',
  AcquisitionCsvAudienceList = 'acquisition_csv_audience_list',
  AcquisitionCsvEnrichment = 'acquisition_csv_enrichment',
  Retention = 'retention',
  RetentionCsv = 'retention_csv',
  RetentionTags = 'retention_tags',
  RetentionActions = 'retention_actions',
  RetentionCsvAudienceList = 'retention_csv_audience_list',
  RetentionCsvEnrichment = 'retention_csv_enrichment',
}

export const ProfileBasedCampaigns = [
  CampaignTypes.AcquisitionCsv,
  CampaignTypes.AcquisitionCsvInstantly,
  CampaignTypes.AcquisitionCsvRb2b,
  CampaignTypes.AcquisitionCsvSquid,
  CampaignTypes.AcquisitionCsvApi,
  CampaignTypes.AcquisitionCsvWebhook,
  CampaignTypes.AcquisitionCsvVector,
  CampaignTypes.AcquisitionCsvZapier,
  CampaignTypes.AcquisitionCsvLikedPost,
  CampaignTypes.RetentionCsv,
  CampaignTypes.RetentionTags,
  CampaignTypes.RetentionActions,
  CampaignTypes.AcquisitionCsvAudienceList,
  CampaignTypes.AcquisitionCsvEnrichment,
  CampaignTypes.RetentionCsvEnrichment,
];
